import { memo } from 'react';

import RotateIconSVG from '@/assets/rotate-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

export type RotateIconProps = Omit<IconProps, 'SVGComponent'> & {
  rotation: 'cw' | 'ccw';
};

const IRotateIcon = ({ rotation, className, ...rest }: RotateIconProps) => {
  /* prettier-ignore */
  const rotationStyles = [
    rotation === 'ccw' && 'scale-x-[-1]',
  ];

  return <Icon SVGComponent={RotateIconSVG} className={merge(rotationStyles, className)} {...rest} />;
};

export const RotateIcon = memo(IRotateIcon) as typeof IRotateIcon;
